import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { pay } from "../lib/api";
import { AuthLayout } from "../components/app/AuthLayout";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const recruiter = params.get("plan") === "recruiter";
  const back = recruiter ? "/recruiter" : "/coach/billing";
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sid) { setState("error"); return undefined; }
    let n = 0;
    let stop = false;
    const tick = async () => {
      try {
        const { data } = await pay.get(`/status/${sid}`);
        if (stop) return;
        if (data?.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(data?.payment_status)) { setState("error"); return; }
      } catch { /* retry */ }
      n += 1;
      if (n >= 15) setState("slow");
      else setTimeout(tick, 2000);
    };
    tick();
    return () => { stop = true; };
  }, [sid]);

  return (
    <AuthLayout tagline={<>Game<br /><span className="text-[#39FF14]">on.</span></>}>
      <div className="space-y-5" data-testid={`payment-${state}`}>
        {state === "checking" && <><Loader2 className="h-10 w-10 animate-spin text-[#39FF14]" /><h1 className="font-display text-5xl font-black uppercase leading-none text-white">Confirming payment…</h1><p className="text-slate-400">This takes a few seconds.</p></>}
        {state === "paid" && <><CheckCircle2 className="h-10 w-10 text-[#39FF14]" /><h1 className="font-display text-5xl font-black uppercase leading-none text-white">You're in.</h1><p className="text-slate-400">{recruiter ? "Your recruiter subscription is active." : "Your team subscription is active."}</p></>}
        {state === "slow" && <><Loader2 className="h-10 w-10 text-amber-300" /><h1 className="font-display text-5xl font-black uppercase leading-none text-white">Still processing.</h1><p className="text-slate-400">Stripe is taking longer than usual. Check your Subscription page in a minute.</p></>}
        {state === "error" && <><XCircle className="h-10 w-10 text-[#FF3B30]" /><h1 className="font-display text-5xl font-black uppercase leading-none text-white">Payment not completed.</h1><p className="text-slate-400">No charge was made. You can try again from the Subscription page.</p></>}
        <Link to={back} data-testid="payment-back-billing" className="inline-block rounded-full bg-[#39FF14] px-6 py-3 font-semibold text-[#0A0E1A]">{recruiter ? "Go to dashboard" : "Go to Subscription"}</Link>
      </div>
    </AuthLayout>
  );
}

export function PaymentCancel() {
  const [params] = useSearchParams();
  const back = params.get("plan") === "recruiter" ? "/recruiter" : "/coach/billing";
  return (
    <AuthLayout tagline={<>No<br /><span className="text-[#39FF14]">charge.</span></>}>
      <div className="space-y-5" data-testid="payment-cancel">
        <h1 className="font-display text-5xl font-black uppercase leading-none text-white">Checkout canceled.</h1>
        <p className="text-slate-400">Nothing was charged. Pick up where you left off any time.</p>
        <Link to={back} data-testid="payment-cancel-back" className="inline-block rounded-full bg-[#39FF14] px-6 py-3 font-semibold text-[#0A0E1A]">Back to Subscription</Link>
      </div>
    </AuthLayout>
  );
}
